'use client';
import { IS_MOBILE } from '@repo/common-utils';
import { useWindowOpen } from '@repo/platform';
import { TextButton, BoxButton } from '@repo/ui';
import { useEffect, useState } from 'react';

import { DefaultContainer } from '@/app/_components/layout-content/LayoutItems';
import { MAIN_SECTION_IMAGES } from '@/lib/constants/landing-sections';

export const MainSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isShowAppDownloadButton, setIsShowAppDownloadButton] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % MAIN_SECTION_IMAGES.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setIsShowAppDownloadButton(IS_MOBILE);
  }, []);

  return (
    <section className={'relative w-full overflow-hidden h-[max(600px,calc(100svh-52px))] ss:h-[max(800px,calc(100svh-52px))]'}>
      <div
        className={
          'relative w-full before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-gradient-to-b before:from-40% before:from-gray-alpha-700 before:to-80% before:to-transparent z-10 h-full'
        }
      >
        <DefaultContainer className={'py-spacious-large h-full hero-title-wrapper'}>
          <div className={'flex flex-col items-center justify-center z-20 text-neutral-foreground-inverse-main hero-title'}>
            <h1 className="backdrop-blur-md backdrop-saturate-180 p-[0.5px] bg-violet-alpha-100 leading-[0] mb-normal-medium rounded-[18px]">
              <img
                src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/brand/icons/symbol_bznav-main.svg`}
                className={'w-[76px] h-[76px]'}
                alt="bznav app icon"
              />
            </h1>
            <h2
              className={
                'highlight-gradient bg-clip-text inline-block bg-neutral-foreground-inverse-main bg-gradient-to-r from-20% from-neutral-foreground-inverse-main via-50% via-violet-200 to-80% to-neutral-foreground-inverse-main shimmer leading-tighter text-center font-bold compact:display-small-bold medium:display-medium-bold display-large-bold z-20'
              }
            >
              모든 세무 고민, <br />
              비즈넵이 해결해드릴게요
            </h2>
            <p className={'font-semibold heading-small-semibold text-center mt-normal-medium mb-0 z-20'}>
              비즈넵 앱으로 복잡한 세무 관리부터 세금 환급, AI 상담까지. <br className={'hidden ss:block'} />
              모든 세무 고민을 한 번에 해결하세요.
            </p>
            {(isShowAppDownloadButton && <AppDownloadButton />) || <AppStoreButtons />}
          </div>
        </DefaultContainer>
      </div>
      <div className={'absolute top-0 left-0 w-full h-full overflow-hidden flex items-center justify-center'}>
        {MAIN_SECTION_IMAGES.map((imgSet, index) => (
          <picture key={index} className={'pointer-events-none absolute w-full h-full left-0 right-0'}>
            {/* 세로 비율 이미지 */}
            <source srcSet={imgSet.portrait.small} media="(max-width: 496px) and (orientation: portrait)" />
            <source srcSet={imgSet.portrait.medium} media="(min-width: 497px) and (orientation: portrait)" />

            {/* 가로 비율 이미지 */}
            <source srcSet={imgSet.landscape.small} media="(max-width: 496px) and (orientation: landscape)" />
            <source srcSet={imgSet.landscape.medium} media="(max-width: 744px) and (orientation: landscape)" />
            <source srcSet={imgSet.landscape.large} media="(min-width: 745px) and (orientation: landscape)" />

            <img
              src={imgSet.landscape.large}
              alt=""
              className={`w-full h-full object-cover transition-all duration-1000 ease-in-out ${index === activeIndex ? 'opacity-100 scale-105' : 'opacity-0 scale-100'}`}
            />
          </picture>
        ))}
      </div>
    </section>
  );
};

const AppDownloadButton = () => {
  const { openWindow } = useWindowOpen();

  return (
    <BoxButton
      variant="filled-primary"
      size="large"
      className={'rounded-full mt-normal-xlarge'}
      onClick={() => {
        openWindow('http://ab.bznav.com/jrja6o');
      }}
    >
      앱 다운로드
    </BoxButton>
  );
};

const AppStoreButtons = () => {
  const { openWindow } = useWindowOpen();

  return (
    <div className={'mt-normal-xlarge flex flex-col ss:flex-row gap-normal-small'}>
      <TextButton
        variant="secondary"
        size="large"
        style={{ borderRadius: '1000px' }}
        className="bg-gray-alpha-inverse-900 backdrop-blur-md"
        onClick={() => {
          openWindow('https://play.google.com/store/apps/details?id=com.emmental.bznav.mobile&hl=ko');
        }}
      >
        <img
          src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/brand/icons/ic_google-store.svg`}
          className={'w-6 h-6 mr-tiny-small'}
          alt="google play icon"
        />
        Google Play
      </TextButton>
      <TextButton
        variant="secondary"
        size="large"
        style={{ borderRadius: '1000px' }}
        className="bg-gray-alpha-inverse-900 backdrop-blur-md"
        onClick={() => {
          openWindow('https://apps.apple.com/kr/app/%EB%B9%84%EC%A6%88%EB%84%B5/id1186216942?l=en');
        }}
      >
        <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/brand/icons/ic_apple.svg`} className={'w-6 h-6 mr-tiny-small'} alt="apple icon" />
        App Store
      </TextButton>
    </div>
  );
};
